import {TextContentModel} from '../models/text.content-model';
import {ContentResourceInterface} from '../interfaces/content-resource.interface';

export const SalaryDividendFormContentResources: ContentResourceInterface & { [id in string]: any } = {


    LastModified: new TextContentModel(
        {'fr': '2025-03-22', 'en': '2025-03-22'},
    ),

    Title: new TextContentModel(
        {'fr': 'Demande d\'analyse Salaires-Dividendes', 'en': 'Get started now'},
    ),

    Meta: {
        Description: new TextContentModel(
            {
                'fr': 'Utilisez Optitax dès aujourd\'hui!\n',
                'en': 'Start using Optitax today!\n',
            },
        ),

        Keywords: new TextContentModel(
            {
                'fr': 'optitax, débutez maintenant gratuitement',
                'en': 'optitax, get started',
            },
        ),
    },

    'get-started.body.title': new TextContentModel(
        {
            'fr': 'Merci de votre intérêt pour l\'analyse Salaires-Dividendes d\'Optitax',
            en: 'Thank you for your interest in the salary dividend analysis by Optitax',
        },
    ),

    'get-started.body.subtitle': new TextContentModel(
        {
            'fr': 'Afin de débuter le processus d’activation, vous devez commencer par remplir le formulaire suivant. Vous serez ensuite inviter à vous créer un compte dans Optitax.',
            en: 'To start the activation process, you must first fill out the following form. You will then be invited to create an account in Optitax.',
        },
    ),
};
